/**
 * =============================================================================
 * PERIODICIDAD DE UN PASO DE TERAPIA — VALOR GUARDADO vs ETIQUETA QUE SE PINTA
 * =============================================================================
 * Hasta ahora la etiqueta ERA el valor: el desplegable ofrecia "Semanal" y eso
 * mismo se guardaba en `periodicity` y se pintaba tal cual en el detalle.
 *
 * Eso convierte una traduccion en una migracion de datos. Si se traduce la
 * etiqueta sin mas, el desplegable empieza a mandar "Hebdomadaire" al backend
 * y las terapias que ya estan guardadas —con la palabra castellana— dejan de
 * casar con ninguna opcion.
 *
 * LA REGLA: el valor NO se toca. Sigue siendo la palabra castellana, que es lo
 * que hay hoy en Atlas. Lo que se traduce es unicamente como se ensena.
 *
 * Un valor que no reconocemos se pinta en crudo a proposito: si alguien mete
 * una periodicidad nueva por otra via, el terapeuta la ve en vez de encontrarse
 * un hueco.
 * =============================================================================
 */

export const PERIODICIDADES = ["Diaria", "Semanal", "Quincenal", "Mensual"];

export const PERIODICIDAD_POR_DEFECTO = "Semanal";

const CLAVE_POR_VALOR = {
  Diaria: "periodicidad.diaria",
  Semanal: "periodicidad.semanal",
  Quincenal: "periodicidad.quincenal",
  Mensual: "periodicidad.mensual",
};

/** Traduce el valor guardado. Lo que no reconoce, en crudo. */
export function etiquetaPeriodicidad(t, valor) {
  const clave = CLAVE_POR_VALOR[valor];
  return clave ? t(clave) : valor || "";
}

/** Opciones del desplegable: valor castellano, etiqueta traducida. */
export function opcionesPeriodicidad(t) {
  return PERIODICIDADES.map((valor) => ({
    value: valor,
    label: etiquetaPeriodicidad(t, valor),
  }));
}
